// Hero Critical - Modular source that builds to Safari-compatible inline output
import { $, $$, ErrorBoundary, safeInit } from './utils.js';
import { CONFIG } from './config.js';
import { CursorAnimation } from './hero/cursor.js';
import { MarqueeModule } from './hero/marquee.js';
import { HeroAnimation } from './hero/heroAnimation.js';

// Setup global error handling
ErrorBoundary.setupGlobalErrorHandling();

// Basic performance setup
if (location.hostname !== 'voiceflow-2025-4af2bdbead8d425d454ee91c.webflow.io') {
  const hints = [{rel: 'dns-prefetch', href: '//fonts.googleapis.com'}];
  hints.forEach(hint => {
    if (!document.querySelector(`link[href="${hint.href}"]`)) {
      const link = document.createElement('link');
      Object.assign(link, hint);
      document.head.appendChild(link);
    }
  });
}

// Service worker registration
if ('serviceWorker' in navigator && location.hostname !== 'voiceflow-2025-4af2bdbead8d425d454ee91c.webflow.io') {
  navigator.serviceWorker.register('/sw.js').catch(() => {});
}

// Image optimization function
const optimizeImages = () => {
  const optimizeImageSet = () => {
    document.querySelectorAll('img[data-src], img:not([loading])').forEach((img, index) => {
      if (index > 2 && !img.hasAttribute('loading')) {
        img.loading = 'lazy';
      }
      if (!img.hasAttribute('decoding')) {
        img.decoding = 'async';
      }
    });
  };
  
  if (window.requestIdleCallback) {
    requestIdleCallback(optimizeImageSet, { timeout: 1000 });
  } else {
    setTimeout(optimizeImageSet, 100);
  }
};

// Content visibility optimization
const optimizeContentVisibility = () => {
  const sections = document.querySelectorAll('section:not(.home_hero), .footer, .nav:not(.home_hero .nav)');
  sections.forEach(section => {
    if (section.getBoundingClientRect().top > window.innerHeight) {
      section.style.contentVisibility = 'auto';
      section.style.containIntrinsicSize = '1px 500px';
    }
  });
};

if (window.requestIdleCallback) {
  requestIdleCallback(optimizeContentVisibility, { timeout: 3000 });
} else {
  setTimeout(optimizeContentVisibility, 3000);
}

// Image optimization on load
if (document.readyState !== 'loading') {
  optimizeImages();
} else {
  document.addEventListener('DOMContentLoaded', optimizeImages);
}

// Main initialization matching pattern from new JS
window.heroReady = new Promise(resolve => {
  const initHero = () => {
    function initAnimations() {
      // FIRST: Set page wrapper opacity IMMEDIATELY (exact match to old script)
      const pageWrapperEl = $(CONFIG.selectors.pageWrapper);
      if (pageWrapperEl) {
        pageWrapperEl.style.opacity = '1';
      }
      
      // SECOND: Initialize modules in correct order - CRITICAL for compatibility
      // MarqueeModule FIRST to establish layout
      safeInit(MarqueeModule);
      // CursorAnimation BEFORE HeroAnimation (required for timeline callbacks)
      safeInit(CursorAnimation);  
      // HeroAnimation LAST (orchestrates everything)
      safeInit(HeroAnimation);
      
      resolve();
    }

    // Exact retry logic from old script
    const heroElement = $(CONFIG.selectors.heroSection);
    if (heroElement) {
      initAnimations();
    } else {
      setTimeout(() => {
        const heroRetry = $(CONFIG.selectors.heroSection);
        if (heroRetry) {
          initAnimations();
        }
      }, CONFIG.timing.domRetryDelay);
    }
  };

  // Exact loading state handling from old script
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHero);
  } else {
    setTimeout(initHero, CONFIG.timing.webflowRenderDelay);
  }
});